export default class StringUtils {
  static normalize(str?: string) {
    if (!str) return str
    return str.normalize('NFKD').replace(/[^\x00-\x7F]/g, '')
  }
}
